/**
 * Service pour les opérations sur les contacts
 * Aucune logique métier, uniquement des appels API
 */

import { api, endpoints } from './api.js'

export const contactsService = {
  list: (params = {}) => {
    const queryString = new URLSearchParams(params).toString()
    const url = queryString ? `${endpoints.quotes.contacts.list()}?${queryString}` : endpoints.quotes.contacts.list()
    return api.get(url)
  },

  listEntreprises: (params = {}) => {
    const queryString = new URLSearchParams(params).toString()
    const url = endpoints.quotes.entreprises.list()
    return api.get(queryString ? `${url}?${queryString}` : url)
  },

  detail: (email, siret, perimetre) => api.get(endpoints.quotes.contacts.detail(email, siret, perimetre)),

  getCalls: (email, siret, perimetre) => api.get(endpoints.quotes.contacts.calls(email, siret, perimetre)),

  getAutomaticEmails: (email, siret, perimetre) => api.get(endpoints.quotes.contacts.automaticEmails(email, siret, perimetre)),

  getUpcomingEmails: (email, siret, perimetre) => api.get(endpoints.quotes.contacts.upcomingEmails(email, siret, perimetre)),

  getLinkedCompanies: (email, siret) => api.get(endpoints.quotes.contacts.linkedCompanies(email, siret)),
  findSimilarCompaniesAi: (email, siret) => api.post(endpoints.quotes.contacts.similarCompaniesAi(email, siret))
}
